import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const useSmartBackV81 = (fallbackPath) => {
  const navigate = useNavigate();

  return useCallback(() => {
    const historyIndex = window.history.state?.idx;
    if (Number.isInteger(historyIndex) && historyIndex > 0) {
      navigate(-1);
      return;
    }
    navigate(fallbackPath, { replace: true });
  }, [fallbackPath, navigate]);
};

export default useSmartBackV81;
